const AppConfig = {
  API_BASE_URL: 'https://lms.coderslab.ro/lms-api',
  PUBLIC_API_BASE_URL: 'https://lms.coderslab.ro/public-api',
  SENTRY_DSN: 'https://5f50c1a3721c42eea3348f2b9444eae1@o203382.ingest.sentry.io/4504101158977536',
  LANG: 'en',
  HUB_URL: '',
  SHOW_GRADEBOOK_TAB: 1,
  LOGIN_REDIRECT_URL: 'https://lms.coderslab.ro/auth/github_connect?redirect_url=',
  COURSE_ICON_BASE_URL: 'https://lms.coderslab.ro/',
  TENANT_USER_LANGUAGES: 'en',
  FEATURE_MATERIAL_ISSUE: 0,
  LOGO: '',
  COURSES_CATALOG_URL: '',
  CONTACT_URL: '',
  USER_ENGAGE_API_KEY: '',
  USER_ENGAGE_SCRIPT_URL: '',
};

export default AppConfig;
